import { Heading_default } from "./chunk-EXW7ZGG6.js";
import { Icon_default } from "./chunk-3BD6RCWY.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Empty/Empty.tsx
import React from "react";
import clsx from "clsx";
var Empty = _a => {
  var _b = _a,
    {
      action,
      icon = "search",
      title,
      description,
      className
    } = _b,
    rest = __objRest(_b, ["action", "icon", "title", "description", "className"]);
  return /* @__PURE__ */React.createElement("div", __spreadValues({
    className: clsx("pd-empty", className)
  }, rest), /* @__PURE__ */React.createElement("figure", {
    className: "pd-empty__icon"
  }, /* @__PURE__ */React.createElement(Icon_default, {
    icon,
    size: "2xl",
    className: "pd-text-dim-500"
  })), /* @__PURE__ */React.createElement("div", {
    className: "pd-empty__content"
  }, /* @__PURE__ */React.createElement(Heading_default, {
    as: "h4",
    variant: "display",
    size: "2",
    className: "pd-empty__title"
  }, title), /* @__PURE__ */React.createElement("div", {
    className: "pd-empty__description"
  }, description)), action && /* @__PURE__ */React.createElement("div", {
    className: "pd-empty__actions"
  }, action));
};
var Empty_default = Empty;
export { Empty_default };